import {twMerge} from '@sdox/utils'

import type {ReactNode} from 'react'
import type {ClassNameValue} from 'tailwind-merge'

interface EntryProps {
  className?: ClassNameValue
  label: string
  value: ReactNode
}
export const Entry = ({className, label, value}: EntryProps) => (
  <div className={twMerge('flex flex-col pt-spacing-2 @block-medium:flex-row @block-medium:gap-spacing-24', className)}>
    <p className={'grow text-glyph-default-secondary'}>{label}</p>
    {value}
  </div>
)
